<template>
  <li class="dropdownItem dropdownItem__managerInfo">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      派遣單資料
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-left">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/transactionList'"
          v-if="permissionTransaction"
        >
          叫車記錄總查詢
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/transactionStatistic'"
          v-if="permissionTransactionStatistics"
        >
          派車單月統計
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/WorkingStatus'"
          v-if="permissionTransactionStatistics"
        >
          大量作業進度
        </router-link>
      </li>
    </ul>
  </li>
</template>
<script>
export default {
  props: ['permissionTransaction', 'permissionTransactionStatistics'],
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownTransaction.vue